import * as React from 'react';

import FadingScrollBars from 'components/FadingScrollBars';

import { block } from '../../utils';
import BlueskyPostButton from '../BlueskyPostButton';
import DownloadButton from '../DownloadButton';
import FacebookPostButton from '../FacebookPostButton';
import InstagramPostButton from '../InstagramPostButton';
import LinkedinPostButton from '../LinkedinPostButton';
import ThreadsPostButton from '../ThreadsPostButton';
import TiktokPostButton from '../TiktokPostButton';
import TwitterPostButton from '../TwitterPostButton';
import YoutubePostButton from '../YoutubePostButton';
import useSocialIntegration, {
  SocialIntegration,
} from './useSocialIntegration';

export interface DownloadPageSocialSectionProps {
  videoFileName?: string;
}

const DownloadPageSocialSection: React.SFC<DownloadPageSocialSectionProps> = ({
  videoFileName,
}) => {
  const socialIntegrations = useSocialIntegration();
  const isSingle = socialIntegrations.length === 1;

  return (
    <div className={block('social-section', { single: isSingle })}>
      <FadingScrollBars horizontal sideFaderClassName={block('side-fader')}>
        <div className={block('social-buttons')}>
          {socialIntegrations.includes(SocialIntegration.TWITTER) && (
            <TwitterPostButton />
          )}

          {socialIntegrations.includes(SocialIntegration.FACEBOOK) && (
            <FacebookPostButton />
          )}

          {socialIntegrations.includes(SocialIntegration.YOUTUBE) && (
            <YoutubePostButton />
          )}

          {socialIntegrations.includes(SocialIntegration.LINKEDIN) && (
            <LinkedinPostButton />
          )}

          {socialIntegrations.includes(SocialIntegration.TIKTOK) && (
            <TiktokPostButton />
          )}

          {socialIntegrations.includes(SocialIntegration.BLUESKY) && (
            <BlueskyPostButton />
          )}

          {socialIntegrations.includes(SocialIntegration.INSTAGRAM) && (
            <InstagramPostButton />
          )}

          {socialIntegrations.includes(SocialIntegration.THREADS) && (
            <ThreadsPostButton />
          )}
        </div>
      </FadingScrollBars>

      <div className={block('download-button')}>
        {socialIntegrations.includes(SocialIntegration.DIRECT_DOWNLOAD) && (
          <DownloadButton fileName={videoFileName} single />
        )}
      </div>
    </div>
  );
};

export default DownloadPageSocialSection;
